Vendd.Scripts.load(function () {
    "use strict"

    var $wrapper = $('[data-search-container]');
    if ($wrapper.length === 0) return;

    var $title = $('.beta-title');
    var $resultsCount = $('.results-count', $title);
    var $noResults = $('.no-results');
    var searchTerm = $wrapper.attr('data-search-term');
    var model = {};
    var wrapper = {};
    model.literals = {};
    model.literals.detailPage = $wrapper.attr('data-literal-detailPage');
    model.literals.stockCars = $wrapper.attr('data-literal-stockCars');
    model.literals.usedCars = $wrapper.attr('data-literal-usedCars');
    model.literals.allDetailsAbout = $wrapper.attr('data-literal-allDetailsAbout');
    model.literals.family = $wrapper.attr('data-literal-family');
    model.literals.allStockCarsAvailable = $wrapper.attr('data-literal-allStockCarsAvailable');
    model.literals.allUsedCarsAvailable = $wrapper.attr('data-literal-allUsedCarsAvailable');
    model.literals.view = $wrapper.attr('data-literal-view');
    model.literals.siteName = skodaVariables.siteName;

    wrapper.bindEvents = function () {
        window.lhSdriveTracking.sendSearchClick(searchTerm, model.resultsCount.toString());
        $('a', $wrapper).click(window.lhSdriveTracking.trackClick);
        $('a', $wrapper).middleClick(window.lhSdriveTracking.trackClick);
    }

    wrapper.noResults = function () {
        $wrapper.html('');
        $noResults.removeClass('hidden');
    }
    
    wrapper.showResults = function () {
        model.resultsCount = model.results.length;
        
        if (model.resultsCount === 0) {

            return wrapper.noResults();

        }

        $resultsCount.text(model.resultsCount);

        $title.removeClass('hidden');

        var html = Vendd.Handlebars.parse("searchResults", model);
        
        $wrapper.html(html);
        
        wrapper.bindEvents();
    }

    model.results = [];

    var terms = searchTerm.split(' ');

    terms.forEach(function (term) {

        var matchedCars = skodaVariables.cars.filter(function (car) { 
            
            return car.title.toUpperCase().includes(term.toUpperCase())
                && !model.results.some(function(x) { return x.type === car.type && x.id === car.id }); 
        
        });

        if (matchedCars.length === 0) { 
            
            return; 
        
        }

        model.results.push.apply(model.results, matchedCars);
    });

    Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetArticleElasticResultsSuccess, wrapper, function (envelope) {
        var articles = envelope.message.data.model.hits.hits;
        if (articles.length === 0) return wrapper.showResults();               
        articles.forEach(function (article) {
            model.results.push({
                isArticle: true,
                title: article._source.Title,
                url: article._source.Url,
                subTitle: article._source.SubTitle
            })
        });
        wrapper.showResults();
    });

    searchTerm = searchTerm.toUpperCase().replace('SKODA', '');
    Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetArticleElasticResults(searchTerm, 1, 100));          
});